import { DateTime } from "luxon"

import { DaysOfWeekType } from "../../merchant/menuPlanning/menuPlanningTypes"
import { PriceListType } from "../priceList/priceListApi"

export enum ExtraServiceType {
    PICKUP_FEE = "PICKUP_FEE",
    EAT_IN_CANTEEN_FEE = "EAT_IN_CANTEEN_FEE",
    DELIVERY_FEE = "DELIVERY_FEE",
    TABLE_SETTING_FEE = "TABLE_SETTING_FEE",
    CLEANUP_FEE = "CLEANUP_FEE",
    OUT_OF_OPENING_HOURS_FEE = "OUT_OF_OPENING_HOURS_FEE",
    OTHER = "OTHER",
}

export enum ExtraServicePricingType {
    PER_SEAT = "PER_SEAT",
    FLAT_FEE = "FLAT_FEE",
}

type ProductGroupCode = {
    id: number
    name?: string
}

export interface BaseExtraService {
    merchant?: {
        id: number
    }
    serviceType: ExtraServiceType
    productGroupCode?: ProductGroupCode
    priceLists?: ReadonlyArray<{ id: number; name?: string }>
    name: string
    description: string
    isActive: boolean
    action?: ExtraServiceActionType
    isMeetingTimeRequired: boolean
    isMeetingLocationRequired: boolean
    availabilityDetails?: {
        weekDays?: DaysOfWeekType[]
        timeInterval?: {
            start: string
            end: string
        }
    }
}

export type ExternalServiceEntry =
    | (Omit<BaseExtraService, "productGroupCode"> & {
          id?: number
          pricingType: ExtraServicePricingType.FLAT_FEE
          price: Price
          productGroupCode?: ProductGroupCode
      })
    | (Omit<BaseExtraService, "productGroupCode"> & {
          id?: number
          pricingType: ExtraServicePricingType.PER_SEAT
          minimumPrice: Price
          maximumPrice: Price
          pricePerSeat: Price
          productGroupCode?: ProductGroupCode
      })

export interface Price {
    amount: number
    scale: number
    currency: string
}

export enum ExtraServiceActionType {
    ADD_ALWAYS = "ADD_ALWAYS",
    ADD_WHEN_PICK_UP = "ADD_WHEN_PICK_UP",
    ADD_WHEN_DELIVERED = "ADD_WHEN_DELIVERED",
}

export type CreateUpdateExtraServiceFormValues = Readonly<
    Omit<BaseExtraService, "id" | "availabilityDetails" | "serviceType" | "action"> & {
        pricingType: ExtraServicePricingType | ""
        serviceType: ExtraServiceType | ""
        priceList?: PriceListType | null
        action?: ExtraServiceActionType | "" | undefined
        serviceTime: {
            weekDays?: DaysOfWeekType[]
            timeInterval?: {
                start: DateTime
                end: DateTime
            }
        }
        minimumPrice?: number
        maximumPrice?: number
        pricePerSeat?: number
        minimumPriceCurrency: string
        maximumPriceCurrency: string
        pricePerSeatCurrency: string
        defaultPrice?: number
        defaultCurrency: string
    }
>
